<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Tripulações"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "tripulacaoTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "tripulacao_id",
        "equipe_id",
        "tripulante_id",
        "status",
        "data_gravacao_f",
        "data_fim_vinculo_f",
        "actions",
      ],
      tableData: [
        "tripulacao_id",
        "equipe_id",
        "tripulante_id",
        "status",
        "data_gravacao_f",
        "data_fim_vinculo_f",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["tripulacao_id", "equipe_id", "tripulante_id", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          tripulacao_id: "ID",
          equipe_id: "Nome da Equipe",
          tripulante_id: "Tripulante",
          status: "Status",
          data_gravacao_f: "Data ínicio",
          data_fim_vinculo_f: "Data fim",
          actions: "Ações",
        },
        sortable: ["tripulacao_id", "equipe_id", "tripulante_id", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 2,
              text: "Inativo",
            },
          ],
        },
        templates: {
          equipe_id: function (h, row, index) {
            return row.equipe ? row.equipe.equipe_nome : "Não informado";
          },
          tripulante_id: function (h, row, index) {
            return row.tripulante ? row.tripulante.tripulante_nome : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["equipe", "tripulante"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "tripulacaos",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        tripulacao_id: "tripulacao_id",
        equipe_id: "equipe[equipe_nome]",
        tripulante_id: "tripulante[tripulante_nome]",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>